import {
  RadioGroupIndicator as RadioGroupIndicatorPrimitive,
  type RadioGroupIndicatorProps as RadioGroupIndicatorPrimitiveProps,
} from "@radix-ui/react-radio-group";

import "./RadioGroupIndicator.css";

import React from "react";

import { cn } from "@/lib/utils";

interface RadioGroupIndicatorProps {
  disabled?: boolean;
}

const RadioGroupIndicator = React.forwardRef<
  React.ElementRef<typeof RadioGroupIndicatorPrimitive>,
  React.ComponentPropsWithRef<typeof RadioGroupIndicatorPrimitive> &
    RadioGroupIndicatorPrimitiveProps &
    RadioGroupIndicatorProps
>(({ disabled }, ref) => (
  <RadioGroupIndicatorPrimitive
    className={cn(
      "flex items-center justify-center w-full h-full relative radio-group-indicator",
      disabled && "radio-group-indicator-disabled",
    )}
    ref={ref}
  />
));

RadioGroupIndicator.displayName = RadioGroupIndicatorPrimitive.displayName;

export { RadioGroupIndicator };
